const CSVFileUpload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={55.91}
    height={55.91}
    {...props}
  >
    <g data-name="Group 5109">
      <path fill="none" d="M0 0h55.91v55.91H0z" data-name="Rectangle 1000" />
      <g data-name="Group 5108">
        <g
          fill="#fff"
          stroke={props?.color || "#000"}
          strokeWidth={2}
          data-name="Rectangle 970"
          transform="translate(11 11)"
        >
          <rect width={34} height={34} stroke="none" rx={17} />
          <rect width={32} height={32} x={1} y={1} fill="none" rx={16} />
        </g>
        <path
          fill="#5f5f5f"
          d="M23.5 22a.5.5 0 1 0 0 1h9a.5.5 0 0 0 0-1Zm4.854 2.146a.5.5 0 0 0-.707 0l-3.5 3.5a.5.5 0 0 0 .707.707l2.646-2.646V33.5a.5.5 0 1 0 1 0v-7.793l2.646 2.646a.5.5 0 1 0 .707-.707Z"
          data-name="Path 1389"
        />
      </g>
    </g>
  </svg>
);

export default CSVFileUpload;
